/**
 * Data visualization: Indigo colors
 */
export var indigo10 = '#b3cbfb';
export var indigo10opacity20solidDark = '#414c5b';
export var indigo20 = '#85aaf3';
export var indigo30 = '#6490e8';
export var indigo30opacity20solidDark = '#324057';
export var indigo40 = '#4c7bd8';
export var indigo40opacity20solid = '#dbe5f7';
export var indigo50 = '#3b68c2';
export var indigo60 = '#2d55a6';
export var indigo60opacity20solid = '#d5dded';
export var indigo70 = '#214284';
export var indigo80 = '#173061';
